import { FunctionComponent } from 'react';
import angle_right_solid from 'src/shared/icons/angle-right-solid.svg';
import arrow_left_solid from 'src/shared/icons/arrow-left-solid.svg';
import { default as arrow_right_solid, default as arrow_right_solid_white } from 'src/shared/icons/arrow-right-solid.svg';
import bell_solid from 'src/shared/icons/bell-solid.svg';
import book_open_solid from 'src/shared/icons/book-open-solid.svg';
import cart_arrow_down_solid from 'src/shared/icons/cart-arrow-down-solid.svg';
import chart_bar_solid from 'src/shared/icons/chart-bar-solid.svg';
import cog_solid from 'src/shared/icons/cog-solid.svg';
import cogs_solid from 'src/shared/icons/cogs-solid.svg';
import coins_solid from 'src/shared/icons/coins-solid.svg';
import comment_dots from 'src/shared/icons/comment-dots.svg';
import comment from 'src/shared/icons/comment.svg';
import comments_dollar_solid from 'src/shared/icons/comments-dollar-solid.svg';
import credit_card from 'src/shared/icons/credit-card.svg';
import cube_solid from 'src/shared/icons/cube-solid.svg';
import cubes_solid from 'src/shared/icons/cubes-solid.svg';
import customizable_products_menu_icon from 'src/shared/icons/customizable_products_menu_icon.svg';
import elementor from 'src/shared/icons/elementor.svg';
import envelope from 'src/shared/icons/envelope.svg';
import file_archive from 'src/shared/icons/file-archive.svg';
import file_csv_solid from 'src/shared/icons/file-csv-solid.svg';
import file_image from 'src/shared/icons/file-image.svg';
import file_invoice_solid from 'src/shared/icons/file-invoice-solid.svg';
import file_pdf from 'src/shared/icons/file-pdf.svg';
import fill_drip_solid from 'src/shared/icons/fill-drip-solid.svg';
import folder_plus_solid from 'src/shared/icons/folder-plus-solid.svg';
import fonticons from 'src/shared/icons/fonticons.svg';
import globe_europe_solid from 'src/shared/icons/globe-europe-solid.svg';
import google from 'src/shared/icons/google.svg';
import grip_horizontal_solid from 'src/shared/icons/grip-horizontal-solid.svg';
import home_solid from 'src/shared/icons/home-solid.svg';
import hotjar from 'src/shared/icons/hotjar.svg';
import icon_3d_rotation from 'src/shared/icons/ic_outline-3d-rotation-solid.svg';
import icons_solid from 'src/shared/icons/icons-solid.svg';
import info_circle_solid from 'src/shared/icons/info-circle-solid.svg';
import key_solid from 'src/shared/icons/key-solid.svg';
import list_alt_solid from 'src/shared/icons/list-alt-solid.svg';
import mail_bulk_solid from 'src/shared/icons/mail-bulk-solid.svg';
import money_bill_wave_solid from 'src/shared/icons/money-bill-wave-solid.svg';
import pencil_ruler_solid from 'src/shared/icons/pencil-ruler-solid.svg';
import portrait_solid from 'src/shared/icons/portrait-solid.svg';
import print_solid from 'src/shared/icons/print-solid.svg';
import question_circle_solid from 'src/shared/icons/question-circle-solid.svg';
import quote_left_solid from 'src/shared/icons/quote-left-solid.svg';
import readme from 'src/shared/icons/readme.svg';
import robot_2 from 'src/shared/icons/robot_2.svg';
import server_solid from 'src/shared/icons/server-solid.svg';
import shapes_solid from 'src/shared/icons/shapes-solid.svg';
import shopping_cart_solid from 'src/shared/icons/shopping-cart-solid.svg';
import signature_solid from 'src/shared/icons/signature-solid.svg';
import sliders_h_solid from 'src/shared/icons/sliders-h-solid.svg';
import store_alt_solid from 'src/shared/icons/store-alt-solid.svg';
import swatchbook_solid from 'src/shared/icons/swatchbook-solid.svg';
import table_solid from 'src/shared/icons/table-solid.svg';
import tags_solid from 'src/shared/icons/tags-solid.svg';
import terminal_solid from 'src/shared/icons/terminal-solid.svg';
import th_list_solid from 'src/shared/icons/th-list-solid.svg';
import times_solid from 'src/shared/icons/times-solid.svg';
import tools_solid from 'src/shared/icons/tools-solid.svg';
import trepunti from 'src/shared/icons/trepunti.svg';
import tshirt_solid from 'src/shared/icons/tshirt-solid.svg';
import user_alt_slash_solid from 'src/shared/icons/user-alt-slash-solid.svg';
import { default as user_alt_solid, default as users_solid } from 'src/shared/icons/user-alt-solid.svg';
import user_tie_solid from 'src/shared/icons/user-tie-solid.svg';
import wand_stars from 'src/shared/icons/wand_stars.svg';
import window_restore from 'src/shared/icons/window-restore-solid.svg';
import wpforms from 'src/shared/icons/wpforms.svg';
import logo_zakeke from 'src/shared/svg/logoZakeke';
import Sparkles from '../../../shared/svg/sparkles';

const items: Map<string, FunctionComponent> = new Map();
items.set('angle_right_solid', angle_right_solid);
items.set('bell_solid', bell_solid);
items.set('book_open_solid', book_open_solid);
items.set('cart_arrow_down_solid', cart_arrow_down_solid);
items.set('cog_solid', cog_solid);
items.set('coins_solid', coins_solid);
items.set('credit_card', credit_card);
items.set('grip_horizontal_solid', grip_horizontal_solid);
items.set('home_solid', home_solid);
items.set('key_solid', key_solid);
items.set('pencil_ruler_solid', pencil_ruler_solid);
items.set('readme', readme);
items.set('tools_solid', tools_solid);
items.set('tshirt_solid', tshirt_solid);
items.set('user_alt_slash_solid', user_alt_slash_solid);
items.set('user_alt_solid', user_alt_solid);
items.set('logo_zakeke', logo_zakeke);
items.set('file_invoice_solid', file_invoice_solid);
items.set('arrow_right_solid', arrow_right_solid);
items.set('cogs_solid', cogs_solid);
items.set('comment', comment);
items.set('comment_dots', comment_dots);
items.set('comments_dollar_solid', comments_dollar_solid);
items.set('cube_solid', cube_solid);
items.set('cubes_solid', cubes_solid);
items.set('elementor', elementor);
items.set('file_image', file_image);
items.set('fill_drip_solid', fill_drip_solid);
items.set('folder_plus_solid', folder_plus_solid);
items.set('fonticons', fonticons);
items.set('icons_solid', icons_solid);
items.set('list_alt_solid', list_alt_solid);
items.set('money_bill_wave_solid', money_bill_wave_solid);
items.set('portrait_solid', portrait_solid);
items.set('print_solid', print_solid);
items.set('quote_left_solid', quote_left_solid);
items.set('server_solid', server_solid);
items.set('signature_solid', signature_solid);
items.set('sliders_h_solid', sliders_h_solid);
items.set('table_solid', table_solid);
items.set('terminal_solid', terminal_solid);
items.set('th_list_solid', th_list_solid);
items.set('wpforms', wpforms);
items.set('file_csv_solid', file_csv_solid);
items.set('swatchbook_solid', swatchbook_solid);
items.set('globe_europe_solid', globe_europe_solid);
items.set('file_archive', file_archive);
items.set('shopping_cart_solid', shopping_cart_solid);
items.set('arrow_right_solid_white', arrow_right_solid_white);
items.set('times_solid', times_solid);
items.set('arrow_left_solid', arrow_left_solid);
items.set('store_alt_solid', store_alt_solid);
items.set('trepunti', trepunti);
items.set('question_circle_solid', question_circle_solid);
items.set('info_circle_solid', info_circle_solid);
items.set('envelope', envelope);
items.set('shapes_solid', shapes_solid);
items.set('hotjar', hotjar);
items.set('google', google);
items.set('pdf-preview', file_pdf);
items.set('window-restore', window_restore);
items.set('users_solid', users_solid);
items.set('customizable_products_menu_icon', customizable_products_menu_icon);
items.set('wpforms', wpforms);
items.set('users_solid', users_solid);
items.set('user_tie_solid', user_tie_solid);
items.set('chart_bar_solid', chart_bar_solid);
items.set('mail_bulk_solid', mail_bulk_solid);
items.set('icon_3d_rotation', icon_3d_rotation);
items.set('tags-solid', tags_solid);
items.set('sparkles', Sparkles);
items.set('robot_2', robot_2);
items.set('wand_stars', wand_stars);

export const GetIcon = (icon: string) => items.get(icon);
